import { JbCartItem } from '@jbhi-fi/apis/src/shopify/types/JbCart';

export const resetLineItemAddToCartProperties = (item: JbCartItem) => {
  const { _marketplaceTieredId, _marketplaceSellerId } = item.properties;
  return {
    ...item.properties,
    _priceAtc: item.final_line_price,
    ...(_marketplaceTieredId && _marketplaceSellerId
      ? {
          _marketplaceTieredIdAtc: _marketplaceTieredId,
          _marketplaceSellerIdAtc: _marketplaceSellerId,
        }
      : {}),
  };
};
